module.exports = "h3,\nh4,\nh5 {\n  margin: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/attacks/attacks.component.less
// module id = ./src/app/attacks/attacks.component.less
// module chunks = main